import { defineMessages } from 'react-intl';

export default defineMessages({
    changeBoundMessage: {
        id: 'endorsement.common.views.change-bound.Your change was bound successfully.',
        defaultMessage: 'Your change was bound successfully.',
    },
    contactAgentMessage: {
        id: 'endorsement.common.views.change-bound.Changes automatically applied.',
        defaultMessage: 'Changes have also been automatically applied to your pending renewed policy. Please contact an Agent with any questions.'
    },
    contactUnderwriterMessage: {
        id: 'endorsement.common.views.change-bound.Changes automatically applied contact underwriter',
        defaultMessage: 'Changes have also been automatically applied to your pending renewed policy. Please contact an Underwriter with any questions.'
    },
    backToPolicy: {
        id: 'endorsement.common.views.contact-agent.Back to Policy',
        defaultMessage: 'Back to Policy'
    },
    backToHome: {
        id: 'endorsement.common.views.contact-agent.Back to Homepage',
        defaultMessage: 'Back to Homepage'
    },
    changeBound: {
        id: 'endorsement.common.views.change-bound.Change is Bound',
        defaultMessage: 'Change is Bound'
    },
    policyIssues:{
        id:'endorsement.common.views.Policy Issued',
        defaultMessage: 'Policy Issued'
    },
    issuedPolicy: {
        id: 'endorsement.common.views.Your change has been issued successfully.',
        defaultMessage: 'Your change has been issued successfully.'
    },
    applyRenewalPolicy: {
        id: 'endorsement.common.views.There is a renewal policy. Click here to apply the changes to the renewal policy.',
        defaultMessage: 'There is a renewal policy. Click here to apply the changes to the renewal policy.'
    },
    applyRenewalPolicyError: {
        id: 'endorsement.common.views.Error Occured while Applying Changes to Renewal Transaction',
        defaultMessage: 'Error Occured while Applying Changes to Renewal Transaction'
    },
    applyRenewalPolicyErrorDesc: {
        id: 'endorsement.common.views.Unable to Apply Changes to Renewal Transaction. Please check latest policy transaction and contact Underwriter.',
        defaultMessage: 'Unable to Apply Changes to Renewal Transaction. Please check latest policy transaction and contact Underwriter.'
    },
    backToRenewalPolicy: {
        id: 'endorsement.common.views.contact-agent.Click here If you DO NOT wish to apply the changes to the renewal policy.',
        defaultMessage: 'Click here If you DO NOT wish to apply the changes to the renewal policy.'
    },
});
